module.exports = __webpack_public_path__ + "media/images/sp/specials/common/frequent/flow_02-ceee2343d199da621f9a856bead32da8.jpg";